
















import { Component, Vue, Prop} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax'
import AbpBase from '../../lib/abpbase'
@Component({
    name:'messageList'
})
export default class MessageList extends AbpBase  {
    initData:any = {
        tableData: {
            title: [
                {
                    title: '标题内容',
                    key: 'title',
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('div', {
                                style: {
                                    type: 'text',
                                    color: '#2D8cF0'
                                },
                                on: {
                                    click: () => {
                                        this.ToDetail(params);
                                    }
                                }
                            }, params.row.data.title)
                        ])
                    }
                },
                {
                    title: '时间',
                    key: 'creationTime',
                    width: 150,
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.creationTime.substring(0,19).replace('Z', '').replace('T', ' '))
                        ])
                    }
                },
                {
                    title: '操作',
                    key: 'action',  
                    width: 120,       
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.Delete(params);
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                },
            ],
            content: [],
            totalCount: 0,
            loading: true
        },
        searchData: {},
        detailData: {
            status: false,
            title: '',
            content: ''
        }
    }
    GetData() {
        this.initData.tableData.loading = true;
        Ajax.get('/api/services/app/Notification/GetAllAsync', {params: this.initData.searchData}).then((res:any)=>{
            this.initData.tableData.content = res.data.result.items;
            this.initData.tableData.totalCount = res.data.result.totalCount;
            this.initData.tableData.loading = false;
        });
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    //详情
    ToDetail(params:any){
        this.initData.detailData.status = true;
        this.initData.detailData.title = params.row.data.title;
        this.initData.detailData.content = params.row.data.content;
        this.initData.detailData.linkUrl = params.row.data.linkUrl;
        console.log(params.row.data);
    }
    //到项目流程详情
    ToWorkFlowDetail(){
        this.$router.push({
            path:this.initData.detailData.linkUrl+"&type=seeInfo"
        })
    }   
    //返回列表
    BackList() {
        this.initData.detailData.status = false;
    }
    //删除
    Delete(params:any) {
        Ajax.delete('/api/services/app/Notification/DeleteAsync?Id='+params.row.id).then(()=>{
            this.$Message.success('删除成功!');
            this.GetData();
        })
    }
    mounted() {
        this.GetData();
    }
}
